<template>
  <div class="text-center">
    <v-dialog v-model="dialog" persistent width="500">
      <v-card>
        <v-card-title class="text-h6 primary white--text"> Escolha um diário </v-card-title>
        <v-select
          id="select-gestao"
          class="px-3 my-5"
          :items="gestoesDeAulas"
          item-text="professor.nome"
          item-value="id"
          :hint="
            gestaoSelecionada?.turma && gestaoSelecionada?.disciplina
              ? `${gestaoSelecionada.turma.descricao}, ${gestaoSelecionada.disciplina.descricao}`
              : ''
          "
          return-object
          label="Selecione o campo abaixo"
          v-model="gestaoSelecionada"
        >
        </v-select>
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn id="btn-fechar" color="red" text @click="fecharDialog"> Fechar </v-btn>
          <v-btn id="btn-abrir" color="primary" text @click="navegar()"> Abrir </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    turma_id: {
      type: Number,
      require: true,
    },
  },
  data() {
    return {
      gestoesDeAulas: [],
      confirmDialog: false,
      gestaoSelecionada: {
        turma: {
          descricao: "",
        },
        disciplina: {
          descricao: "",
        },
        id: null,
      },
    };
  },
  watch: {
    turma_id: {
      handler() {
        this.listarGestaoDeAulasDaTurma();
      },
    },
  },
  methods: {
    fecharDialog() {
      this.gestaoSelecionada = {
        turma: { descricao: "" },
        disciplina: { descricao: "" },
        id: null,
      };
      this.$emit("dialogChange", false);
    },
    async listarGestaoDeAulasDaTurma() {
      this.gestoesDeAulas = await this.$services.gestoesDeAulasService.listarGestaoDeAulasDaTurma(
        this.turma_id
      );
    },
    async navegar() {
      // this.gestoesDeAulas = await this.$services.aulasService.syncAll(this.gestaoSelecionada);
      this.$router.push({
        name: "relatorios.visualizar",
        params: {
          gestaoDeAulasId: this.gestaoSelecionada.id,
          turmaId: this.gestaoSelecionada.turma_id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
